'use strict';

intellidealerAppCoreModule.factory('dealershipLinksResource', function ($resource, appConfigurationService) {
  return {
    myDealerDealershipLinks: $resource(appConfigurationService.basePath + '/rest/dealershiplinks/myDealerDealershipLinks'),
    myDealerTermsAndConditionsLinks: $resource(appConfigurationService.basePath + '/rest/dealershiplinks/myDealerTermsAndConditionsLinks', null, {get: {method: 'GET', isArray: true}})
  }
});
